import { isLocaleValid } from "./Validators";
/**
 * This function returns language and countryCode from locale string.
 *
 * @param locale Format based on ISO format for language (ISO 639-1) and country code (ISO 3166-1 alpha-2). The language
 * and country should be separated using an underscore ( _ ).
 *
 * @returns LocaleData or null
 */
export var getValuesFromLocale = function (locale) {
    if (!isLocaleValid(locale)) {
        return null;
    }
    var localeSplit = locale.split("_");
    var localeData = {
        lang: localeSplit[0],
        countryCode: localeSplit[1],
    };
    return localeData;
};
/**
 * This function returns button lang depending on the params. If buttonParams is passed it returns value from it, else
 * returns button lang from the initSdk locale data.
 *
 * @param buttonParams
 * @param initSdkLocaleData
 * @returns string or null
 */
export var getButtonLang = function (buttonParams, initSdkLocaleData, ecomSdk) {
    var buttonLocaleData;
    if (buttonParams.buttonLocale) {
        buttonLocaleData = getValuesFromLocale(buttonParams.buttonLocale);
    }
    else {
        buttonLocaleData = initSdkLocaleData;
    }
    if (!buttonLocaleData) {
        return null;
    }
    switch (ecomSdk) {
        case "PAYAIR_APPLE_PAY_SDK":
            return "".concat(buttonLocaleData.lang, "-").concat(buttonLocaleData.countryCode);
        case "PAYAIR_GOOGLE_PAY_SDK":
            return buttonLocaleData.lang;
        default:
            return null;
    }
};
